module.exports = __webpack_public_path__ + "d1bb8ebf9d45ad03e0e36b52cc779d56.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-34@2x.png
// module id = 513
// module chunks = 0